import { tokens } from '@fluentui/react-components';
import { themes } from '../../../themes';

const menuHeight = '3rem';
const pageHeight = (offset?: string) => `calc(100vh - ${menuHeight} - 1.25rem - ${offset || '0rem'})`;
const controlBackground = tokens.colorNeutralBackground3;

const foreground = {
    primary: tokens.colorBrandForeground1,
    primaryHover: tokens.colorCompoundBrandForeground1Hover,
    primaryPressed: tokens.colorCompoundBrandForeground1Pressed,
    success: tokens.colorStatusSuccessForeground1,
    danger: tokens.colorStatusDangerForeground1,
    warning: tokens.colorStatusWarningForeground1,
    disabled: tokens.colorNeutralForegroundDisabled,
    neutral: tokens.colorNeutralForeground1,
};
const textColors = {
    default: tokens.colorNeutralForeground1,
    brand: tokens.colorBrandForeground2,
    disabled: tokens.colorNeutralForeground4,
    caption: tokens.colorNeutralForeground3,
    danger: tokens.colorStatusDangerForeground1,
    success: tokens.colorStatusSuccessForeground1,
};

export const appTokens = {
    menuHeight,
    pageHeight,
    transitionDuration: '.5s',
    border: {
        colors: {
            subtle: tokens.colorNeutralStroke1,
            brand: tokens.colorBrandStroke1,
            status: {
                danger: tokens.colorStatusDangerBorderActive,
                warning: tokens.colorStatusWarningBorderActive,
                success: tokens.colorStatusSuccessBorderActive,
            },
        },
    },
    card: {
        background: tokens.colorNeutralCardBackground,
    },
    dateControl: {
        background: (isPast: boolean) => (!isPast ? tokens.colorNeutralBackground1 : tokens.colorNeutralCardBackground),
    },
    eventControl: {
        background: controlBackground,
        borderLeftStyle: `5px solid #a481f6`,
        borderRadius: '0px 8px 8px 0px',
    },
    font: {
        weight: {
            bold: tokens.fontWeightBold,
            regular: tokens.fontWeightRegular,
        },
    },
    foregrounds: {
        primary: foreground.primary,
        primaryHover: foreground.primaryHover,
        primaryPressed: foreground.primaryPressed,
        success: foreground.success,
        danger: foreground.danger,
        warning: foreground.warning,
        disabled: foreground.disabled,
        neutral: foreground.neutral,
    },
    kpiTile: {
        background: tokens.colorNeutralBackground1,
    },
    menu: {
        backgroundColor: tokens.colorNeutralBackground1,
        backgroundColorHover: tokens.colorBrandBackgroundHover,
        backgroundColorPressed: tokens.colorBrandBackgroundPressed,
        backgroundColorSelected: tokens.colorBrandBackgroundSelected,
        color: tokens.colorNeutralStrokeOnBrand2,
        shadow: tokens.colorBrandShadowKey,
    },
    noteControl: {
        self: tokens.colorNeutralBackground2,
        others: tokens.colorBrandBackground2,
    },
    pages: {
        background: tokens.colorNeutralBackground1,
    },
    partyControl: {
        background: controlBackground,
    },
    shadow: {
        shadow16: tokens.shadow16,
    },
    sparkline: {
        stroke: tokens.colorNeutralStrokeAccessible,
    },
    table: {
        header: {
            background: tokens.colorNeutralBackground5,
            backgroundHover: tokens.colorNeutralBackground5Hover,
            border: tokens.colorBrandStroke1,
        },
    },
    taskControl: {
        borderLeftStyle: `5px solid ${tokens.colorBrandForeground1}`,
        borderRadius: '0px 8px 8px 0px',
        background: controlBackground,
    },
    text: {
        colors: {
            default: textColors.default,
            brand: textColors.brand,
            disabled: textColors.disabled,
            danger: textColors.danger,
            success: textColors.success,
            caption: textColors.caption,
            subtle: tokens.colorNeutralStroke1,
        },
    },
    themes: {
        darkTheme: themes.blueishDarkTheme,
        lightTheme: themes.blueishLightTheme,
    },
    timeEntryControl: {
        borderRadius: '0px 8px 8px 0px',
        borderLeftStyle: (isBillable?: boolean) => `5px solid ${isBillable ? foreground.success : foreground.neutral}`,
        backgroundColor: (invoiceId?: string) =>
            !invoiceId ? controlBackground : tokens.colorNeutralCardBackgroundDisabled,
    },
    verticalMenu: {
        background: tokens.colorBrandBackground4Static, //tokens.colorNeutralBackground5,
        background2: tokens.colorBrandBackground2, //tokens.colorNeutralBackground5,
        railWidth: '3.5rem',
        rightBorderColor: tokens.colorNeutralBackground1Selected,
        menuItemBackground: tokens.colorBrandBackground4Static, //tokens.colorNeutralBackground5,
        menuItemBackgroundHover: tokens.colorBrandBackgroundHover, //tokens.colorNeutralBackground1Hover,
        menuItemBackgroundSelected: tokens.colorBrandBackgroundSelected,
        menuItemColor: tokens.colorNeutralStrokeOnBrand2,
        menuItemColorHover: tokens.colorNeutralStrokeOnBrand2Hover,
        menuItemColorFocus: tokens.colorNeutralStrokeOnBrand2Pressed,
        menuItemColorSelected: tokens.colorNeutralStrokeOnBrand2Selected,
    },
};
